import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { IPrivateConnectionInfo } from '../../models/PrivateConnectModels';


export interface GetPrivateConnectionsTypeParams {
  tenantId: string;
}

export interface GetPrivateConnectionsResult {
  status: string;
  message: string;
  items?: IPrivateConnectionInfo[];
}

function getPrivateConnectionsConfig(params: GetPrivateConnectionsTypeParams): AxiosRequestConfig {
  return {
    method: 'GET',
    url: 'privateconnections',
    params: params
  };
}

export function callGetPrivateConnections(params: GetPrivateConnectionsTypeParams): Promise<IPrivateConnectionInfo[]> {
    return axios.request<GetPrivateConnectionsResult>(getPrivateConnectionsConfig(params))
    .then((result: AxiosResponse<GetPrivateConnectionsResult>) => Promise.resolve(result.data.items))
    .catch(() => {
      return Promise.resolve([]);
    });
  }
